import React from 'react'
import BackButton from "../common/ui/backbutton";
import Pagetitle from "../common/ui/pagetitle";
import Breadcrumb from "../common/ui/breadcrumb";


export default function Editdispatchheader() {
    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
            {/* Left side: Back button + Breadcrumb */}
            <div className="flex items-center gap-3 flex-wrap">
                <BackButton to="/dispatch" />
                <Breadcrumb />
            </div>

            {/* Right side: Page Title */}
            <Pagetitle title="Edit Dispatch" />
        </div>
    )
}
